import ViewDriveRole from 'modules/Exp-Candidates/ViewDrive/index'
import driveSelector from 'modules/Exp-Candidates/selectors'
import { connect } from 'react-redux'

import newDriveSelector from 'modules/Drives/selectors'
import {
  addInterviewer,
  addTimeBreak,
  deleteInterviewer,
  getDriveInterviewerList,
  getDriveRoleMetrics,
  getIndidualDriveData,
  getIndidualDriveMetrics,
  getInterviewerList,
  getRoleMetrics,
  getTopicsList,
  postPassingScore,
  postShortlistCandidates,
  updateInterview,
} from 'modules/Exp-Candidates/actions'

import { getUserRoles } from 'modules/Auth/actions'
import {
  getNewDriveFreshersList,
  getNewDriveScore,
  getNewDriveStatus,
  getNewIndividualDriveStatus,
  getPanelList,
} from 'modules/Drives/actions'

const mapStateToProps = state => ({
  driveRolesMetrics: driveSelector.getDriveRoleMetrics(state),
  rolesMetrics: driveSelector.getRoleMetrics(state),
  driveMetricsData: driveSelector.getDriveMetrics(state),
  driveData: driveSelector.getDriveData(state),
  interViewerList: driveSelector.getInterViewerList(state),
  driveInterViewerList: driveSelector.getDriveInterViewerList(state),
  newFreshersListData: newDriveSelector.getFreshersList(state),
  newDriveStatusData: newDriveSelector.getNewDriveStatus(state),
  newDriveScoreData: newDriveSelector.getNewDriveScore(state),
  newDriveScore: newDriveSelector.getNewDriveMetrics(state),
  newDriveMetrics: newDriveSelector.getNewDriveMetrics(state),
})
const mapDispatchToProps = {
  getIndidualDriveData,
  getIndidualDriveMetrics,
  getDriveRoleMetrics,
  getInterviewerList,
  updateInterview,
  getDriveInterviewerList,
  addInterviewer,
  deleteInterviewer,
  getUserRoles,
  addTimeBreak,
  getRoleMetrics,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
  getNewIndividualDriveStatus,
  getPanelList,
  getNewDriveFreshersList,
  getNewDriveStatus,
  getNewDriveScore,
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewDriveRole)
